import React, { useState, useEffect } from "react";
import tw, { TwStyle } from "twin.macro";

type Props = {
  isOn: boolean;
  color?: TwStyle;
  onClick: () => void;
  initialValue?: boolean;
};

const Toggle: React.FC<Props> = props => {
  const [color, setColor] = useState<TwStyle>();
  const [css, setCss] = useState<TwStyle>(
    tw`relative inline-block flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:shadow-outline`
  );
  const [cssBtn, setCssBtn] = useState<TwStyle>(
    tw`inline-block h-5 w-5 rounded-full bg-white shadow transform transition ease-in-out duration-200`
  );

  const [isOn, setIsOn] = useState<boolean>(props.initialValue);

  useEffect(() => {
    setIsOn(props.isOn);
  }, [props.isOn]);

  useEffect(() => {
    if (props.color) {
      setColor(props.color);
    } else {
      setColor(tw`bg-blue-600`);
    }
  }, [props.color]);

  return (
    <span
      role="checkbox"
      aria-checked={isOn}
      tabIndex={0}
      onClick={props.onClick}
      css={[css, isOn ? color : tw`bg-gray-200`]}
    >
      <span
        aria-hidden="true"
        css={[cssBtn, isOn ? tw`translate-x-5` : tw`translate-x-0`]}
      ></span>
    </span>
  );
};

export default Toggle;
